// src/data.js
export default [
  {
    imageUrl: require('./assets/Certificate/01c-min.jpg'),
    caption: 'گواهی نامه صلاحیت خدمات مشاوره ',
    secondaryCaption: 'سازمان برنامه و بودجه کشور',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/01c-min.jpg'),
        description: 'گواهی نامه صلاحیت خدمات مشاوره سازمان برنامه و بودجه کشور'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/02c-min.jpg'),
    caption: 'استاندارد کیفیت مشاوره ISO9001',
    secondaryCaption: 'تحت لیسانس آلمان',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/02c-min.jpg'),
        description: 'استاندارد کیفیت مشاوره تحت لیسانس آلمان ISO9001'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/03c-min.jpg'),
    caption: 'گواهی نامه طراحی لرزه ای ساختمان',
    secondaryCaption: 'تحت لیسانس ژاپن',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/03c-min.jpg'),
        description: 'گواهی نامه طراحی لرزه ای ساختمان تحت لیسانس ژاپن'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/04c-min.jpg'),
    caption: 'گواهی نامه سیستم امنیت اسناد',
    secondaryCaption: 'تحت لیسانس آلمان',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/04c-min.jpg'),
        description: 'گواهی نامه سیستم امنیت اسناد تحت لیسانس آلمان'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/05c-min.jpg'),
    caption: 'گواهی نامه سیستم اطلاعات مدیریت',
    secondaryCaption: 'تحت لیسانس آلمان',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/05c-min.jpg'),
        description: 'گواهی نامه سیستم اطلاعات مدیریت تحت لیسانس آلمان'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/06c-min.jpg'),
    caption: 'لوح تقدیر ',
    secondaryCaption: 'شهرداری منطقه 9',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/06c-min.jpg'),
        description: 'لوح تقدیر شهرداری منطقه  9 جهت تهیه و تدوین طرح تفضیلی شهرک مدرن خاوران تبریز '
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/07c-min.jpg'),
    caption: 'لوح تقدیر ',
    secondaryCaption: 'شرکت تعاونی مسکن ماشین سازی تبریز',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/07c-min.jpg'),
        description: 'لوح تقدیر شرکت تعاونی مسکن ماشین سازی تبریز جهت بازنگری طرح 170 هکتاری شهرک شهید صیاد شیرازی'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/08c-min.jpg'),
    caption: 'لوح تقدیر',
    secondaryCaption: 'جایزه معماری میرمیران',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/08c-min.jpg'),
        description: 'لوح تقدیر جایزه معماری میرمیران طرح منتخب طراحی ساختمان های بلند مرتبه'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/09c-min.jpg'),
    caption: 'نامزد دریافت جایزه ',
    secondaryCaption: 'برترین پروژه فرهنگی سال 2017',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/09c-min.jpg'),
        description: 'نامزد دریافت جایزه برترین پروژه فرهنگی سال 2017 خاورمیانه برای طرح آرامکاه پروفسور حسابی در تفرش'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/10c-min.jpg'),
    caption: 'لوح تقدیر',
    secondaryCaption: 'کرسی یونسکو',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/10c-min.jpg'),
        description: 'لوح تقدیر کرسی یونسکو در معماری اسلامی برای طرح منتخب مسابقه آرامگاه شمس تبریزی در خوی'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/11c-min.jpg'),
    caption: 'لوح تقدیر',
    secondaryCaption: 'مهندس نمونه استان آذربایجان شرقی',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/11c-min.jpg'),
        description: 'لوح تقدیر مهندس نمونه استان آذربایجان شرقی برای مدیر بخش معماری شرکت پردیس آمایش سرزمین'
      },
    ]
  },
  {
    imageUrl: require('./assets/Certificate/12c-min.jpg'),
    caption: 'لوح تقدیر',
    secondaryCaption: 'طرح برتر مسابقه',
    secondaryImages: [
      {
        imageUrl: require('./assets/Certificate/12c-min.jpg'),
        description: 'لوح تقدیر طرح برتر مسابقه آرامگاه شمس تبریزی در خوی'
      },
    ]
  },

  
    
    // Add more data as needed
  ];